<template>
  <div class="w-100 h-100">
    <dv-border-box-7>
      <div class="h-100">
        <div class="w-100 h-100 p-tb" id="passRateEchart"></div>
      </div>
      <div class="tooltip-container">
        <el-tooltip effect="dark" content="最近7天合格率，按检验时间查询,检验数量/总数量，按日期分组显示。" placement="top-start">
          <i class="el-icon-question" style="font-size:16px;"></i>
        </el-tooltip>
      </div>
    </dv-border-box-7>
  </div>
</template>

<script>
export default {
  name: "pass-rate",
  props: {
    beans: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {
      dataList: this.beans,
      startCharts: null,
    };
  },
  watch: {
    beans: {
      handler: function (val, oldVal) {
        this.dataList = val;
        this.lineEchart();
      },
      deep: true,
    },
  },
  mounted() {
    // this.lineEchart();
  },
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
    lineEchart() {
      var lineEchart = this.$echarts.init(
        document.getElementById("passRateEchart")
      );

      var data = this.dataList;

      const xAxis = [];
      const lineData = [];
      const barData = [];
      const closedCount = [];
      let periodText = "";
      data.forEach((item) => {
        switch (item.type) {
          case 'year': periodText = '年';
            break;
          case 'month': periodText = '月';
            break;
          case 'day': periodText = '日';
        }
        xAxis.push(item.period + periodText);
        barData.push(item.passCount);
        closedCount.push(item.noPassCount);
        var rate = 0.00;
        if (item.issueCount > 0) {
          rate = item.passCount / item.issueCount * 100;
        }
        lineData.push(rate.toFixed(2));

      });
      var option = {
        title: {
          text: "合格率",
          left: "10",
          textStyle: {
            color: "#ffffff",
            fontSize: this.fontSize(0.30),
          },
        },
        tooltip: {
          trigger: "axis",
          extraCssText: 'z-index: 99 !important;',
        },
        legend: {
          data: ["合格", "不合格", "合格率"],
          lfet: '50%',
          textStyle: {
            color: "#ffffff", //字体颜色
            fontSize: this.fontSize(0.15),
          },
          itemGap: 2,
          show: true
        },
        grid: {
          left: "3%",
          right: "10",
          bottom: "0",
          top: "25%",
          y2: 40,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xAxis,
            axisPointer: {
              type: "shadow",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              }
            },
            axisLabel: {
              interval: 0,
              textStyle: {
                color: "#ffffff", //字体颜色
                fontSize: this.fontSize(0.20),
              }
              //     rotate: 25,
            },
          },
        ],
        yAxis: [
          {
            name: '数量',
            nameTextStyle: {
              fontSize: this.fontSize(0.20),
            },
            type: "value",
            min: 0,
            axisLabel: {
              formatter: "{value}",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          },
          {
            name: '合格率',
            nameTextStyle: {
              fontSize: this.fontSize(0.20),
            },
            type: "value",
            axisLabel: {
              formatter: "{value} %",
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
            splitLine: {
              show: false,
            },
          }
        ],
        series: [
          {
            color: ['#3398DB'],
            name: '合格',
            type: 'bar',
            data: barData,
            stack: "total",
            yAxisIndex: 0,
            barGap: '-100%', // Make series be overlap
            itemStyle: {
              normal: {
                label: {
                  show: true, // 开启显示
                  position: 'inside', // 在上方显示
                  textStyle: { // 数值样式
                    color: '#fff',
                    fontSize: this.fontSize(0.20)
                  },
                  formatter: function (params) {
                    return params.value === 0 ? '' : `${params.value}`;  // 如果数值为0，不显示
                  },
                }
              }
            }
          },
          {
            color: ['#F25346'],
            name: '不合格',
            type: 'bar',
            stack: "total",
            yAxisIndex: 0,
            data: closedCount,
            itemStyle: {
              normal: {
                label: {
                  show: true, // 开启显示
                  position: 'inside', // 在上方显示
                  textStyle: { // 数值样式
                    color: '#fff',
                    fontSize: this.fontSize(0.20)
                  },
                  formatter: function (params) {
                    return params.value === 0 ? '' : `${params.value}`;  // 如果数值为0，不显示
                  },
                }
              }
            }
          },
          {
            name: '合格率',
            type: 'line',
            yAxisIndex: 1,
            data: lineData,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#F25346", //改变折线颜色
                },
                label: {
                  show: true, // 开启显示
                  position: 'top', // 在上方显示
                  textStyle: { // 数值样式
                    color: '#fff',
                    fontSize: this.fontSize(0.20)
                  },
                  formatter: function (params) {
                     if (params.value === '0.00') {
                        return '';
                      } else if (params.value === '100.00') {
                        return '100%';
                      } else {
                        return `${params.value}%`;
                      }
                  },
                }
              }
            }
          }
        ],
      };

      lineEchart.setOption(option);
      //图标随窗口大小缩放
      window.addEventListener("resize", function () {
        lineEchart.resize();
      });

      if (this.startCharts) {
        clearInterval(this.startCharts);
      }

      var index = 0; //显示tooltip,播放所在下标
      this.startCharts = setInterval(function () {
        lineEchart.dispatchAction({
          type: "showTip",
          seriesIndex: 0,
          dataIndex: index,
        });
        index++;
        if (index >= data.length) {
          index = 0;
        }
      }, 2000);
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>


<style scoped>
.tooltip-container {
  right: 0;
  bottom: 0;
  position: absolute;
  z-index: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/nok/component/pass-rate.vue